import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Layout } from "../components/tag/Layout";
import { useAuth, formatApiError } from "../contexts/AuthContext";

export default function PortalLogin() {
  const nav = useNavigate();
  const loc = useLocation();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      const next = new URLSearchParams(loc.search).get("next") || "/portal";
      nav(next, { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout title="Customer Portal Login | The Authority Gap" path="/portal/login">
      <section style={{ background: "#090909", padding: "80px 20px" }}>
        <div className="tag-card" data-testid="portal-login-card" style={{ maxWidth: 420, margin: "0 auto", padding: 32 }}>
          <h2 className="tag-h2" style={{ marginBottom: 6 }}>Portal Login</h2>
          <p style={{ color: "#888", fontSize: 12, marginBottom: 24 }}>Customer access for Audit, Blueprint, Launch Kit, and Build buyers.</p>
          <form onSubmit={submit}>
            <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>Email</label>
            <input data-testid="portal-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="tag-input" style={{ marginBottom: 14 }} />
            <label style={{ color: "#888", fontSize: 11, fontWeight: 600 }}>Password</label>
            <input data-testid="portal-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="tag-input" style={{ marginBottom: 20 }} />
            <button data-testid="portal-login-submit" type="submit" className="btn-primary" style={{ width: "100%" }} disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </button>
          </form>
          <div style={{ marginTop: 18, display: "flex", justifyContent: "space-between", fontSize: 12 }}>
            <Link to="/portal/register" data-testid="portal-login-register-link" style={{ color: "#FF6575" }}>Create account</Link>
            <Link to="/portal/forgot" data-testid="portal-login-forgot-link" style={{ color: "#777" }}>Forgot password?</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
